import { render, staticRenderFns } from "./pushNotifications.vue?vue&type=template&id=1b317d5c"
import script from "./pushNotifications.vue?vue&type=script&lang=js"
export * from "./pushNotifications.vue?vue&type=script&lang=js"
import style0 from "./pushNotifications.vue?vue&type=style&index=0&id=1b317d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports